import {
  DEPARTMENT_ASSIGNMENT_HISTORY_TYPE_LABELS,
  DepartmentAssignmentHistoryTypeEnum
} from '../model/departmentAssignmentHistory';

export interface DepartmentAssignmentHistoryFilterOption {
  id: number;
  label: string;
  value: number | null;
}

const TYPE_ORDER = [
  DepartmentAssignmentHistoryTypeEnum.Manual,
  DepartmentAssignmentHistoryTypeEnum.Auto,
  DepartmentAssignmentHistoryTypeEnum.Scheduled
] as const;

export const departmentAssignmentHistoryTypeFilterOptions: DepartmentAssignmentHistoryFilterOption[] = [
  { id: -1, label: 'Все', value: null },
  ...TYPE_ORDER.map((value) => ({
    id: value,
    label: DEPARTMENT_ASSIGNMENT_HISTORY_TYPE_LABELS[value],
    value
  }))
];
